export enum DeliveryNoteTabName {
  Order = 'kopfau',
  PurchaseOrder = 'kopfbs',
}
